module.exports = __webpack_public_path__ + "static/BigBang_UAU_SP22-62820ee969ad2b74eec3044860e0e83e.mp4";